import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Slider from 'react-slick';

import { hideModalHeader, closePopup } from '../../Modal/action';

import SubTabContent from '../../../landing/AboutUs/SubTabContent';
import './style.scss';


@connect((state)=>({
    subscribeResult: state.product.productList.subscribeResult,
}),(dispatch)=>({
    ...bindActionCreators({hideModalHeader},dispatch),
    ...bindActionCreators({closePopup},dispatch),
}))
export default class TrusteeDetail extends Component {

    constructor(props){
        super(props);
    }

    render() {
        const settings = {
            swipe: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 500,
            autoplaySpeed: 3000,
            draggable: false,
            infinite:false,
            arrows: true,
            adaptiveHeight: true,
            initialSlide: this.props.selectedTrustee,
        };
        let { closePopup, modalData} = this.props;
        return (
            <div className="modal-body">
                <i className='icon-close cross' onClick={this.props.closePopup}/>
                <Slider {...settings} ref={c => this.slider = c } >
                    {modalData && modalData.trusteesListContent &&  modalData.trusteesListContent.trusteesList &&
                    modalData.trusteesListContent.trusteesList.map((item, idx)=>{
                        return <div className="trustee-desc" key={idx}>
                            {item &&<SubTabContent item={item}/>}
                        </div>
                    })}
                    {modalData && modalData.trusteesListContent &&  modalData.trusteesListContent.committeeList &&
                    modalData.trusteesListContent.committeeList.map((item, idx)=>{
                        return <div className="trustee-desc" key={idx}>
                            {item &&<SubTabContent item={item}/>}
                        </div>
                    })}

                </Slider>
                  </div>
        );
    }
}

